var defaultTemplates = {
  resetLabel: function resetLabel() {
    return 'Clear refinements';
  }
};
export default defaultTemplates;